import slide from '~/components/molecules/m-slide/m-slide-v2.data'
export default {
  slide_autoplay: true,
  nav: [
    {
      copy_previous: 'Previous',
      copy_next: 'Next',
      copy_of: null,
      component: 'm-carousel-nav',
    },
  ],
  slides: [
    {
      ...slide,
    },
    {
      ...slide,
      eyebrow: 'Volkswagen',
      heading: "The People's Super Car",
      image: {
        alt: 'Image showing the GTI Superdrive surrounded by mountains',
        filename:
          '//a.storyblok.com/f/46530/1480x833/1d7b7efcf3/01-hero-vw-gtisuperdrives-001.png',
      },
    },
    {
      ...slide,
      eyebrow: 'Volkswagen',
      heading: 'Innovation in the DNA',
      image: {
        alt: 'Image showing the classic Volkswagen Campervan',
        filename:
          '//a.storyblok.com/f/46530/1480x833/388cdd277a/01-hero-vw-collectables-001.png',
      },
      video: {
        alt: 'Article Video',
        filename: null,
        temp: '//a.storyblok.com/f/46530/x/05859de4bd/hero-003-desk.mp4',
      },
      youtube: {
        url: 'https://www.youtube.com/watch?v=2CCNswShJRc',
        temp: 'https://www.youtube.com/watch?v=2CCNswShJRc',
      },
      vimeo: {
        url: '',
        temp: 'https://vimeo.com/343460749',
      },
    },
  ],
}
